export default __webpack_public_path__ + "static/media/557.16472faa.png";